import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./TradeRadarAlgoFbHowItWorks.css";
import TradeRadarAlgoFbHowItWork from "../../../../src/Images/landing/Traderadar-Algo/TradeRadarAlgoFbHowItWork.png";
import Advancetools from "../../../../src/Images/landing/Traderadar-Algo/Advance-tools.png";
import StrategyBuilding from "../../../../src/Images/landing/Traderadar-Algo/Strategy-building.png";
import EfficientBacktesting from "../../../../src/Images/landing/Traderadar-Algo/Efficient-backtesting.png";
import LegwiseStoploss from "../../../../src/Images/landing/Traderadar-Algo/Legwise-stoploss.png";
import OptionSimulator from "../../../../src/Images/landing/Traderadar-Algo/Option-simulator.png";
import GetTrades from "../../../../src/Images/landing/Traderadar-Algo/Get-trades.png";

const data = [
  { id: 1, imgname: Advancetools, title: "Advance automation tools to automate your trading" },
  { id: 2, imgname: StrategyBuilding, title: "Strategy building wizard to select multiple strategies" },
  { id: 3, imgname: EfficientBacktesting, title: "Efficient backtesting mechanism to remove errors" },
];
const data2 = [
  { id: 1, imgname: LegwiseStoploss, title: "Legwise stoploss and target" },
  { id: 2, imgname: OptionSimulator, title: "Option simulator for manual backtesting" },
  { id: 3, imgname: GetTrades, title: "Get trades executed @ 10rs/order only" },
];
function TradeRadarAlgoFbHowItWorks() {
  return (
    <>
      <section className="TradeRadarAlgoFbHowItWork_section">
        <h2>Automate and backtest your<span> trading strategies</span></h2>
        <Container>
          <div className="TradeRadarAlgoFbHowItWork_grid">
            <Row>
              <Col lg={5} md={12}>
              <div  className="TradeRadarAlgoFbHowItWork_grouppanel">
                {data.map((value, index) => {
                  return (
                    <div Key={index} className="TradeRadarAlgoFbHowItWork_panel text-center">
                      <div className="TradeRadarAlgoFbHowItWork_img">
                        <img src={value.imgname} />
                      </div>
                        <h3>{value.title}</h3>
                      </div>
                    );
                    }
                    )
                    }
                </div>
                <a className="knowmore-automatebaskt blue" href="#">Know More</a>
              </Col>
               <Col lg={7} md={12}>
              
                <div className="TradeRadarAlgoFbHowItWork_videopanel  ">
                    <img src={TradeRadarAlgoFbHowItWork}></img>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>

       <section className="TradeRadarAlgoFbHowItWork_section HowItWork2">
        <div className="TradeRadarAlgoFbHowItWork_inner">
        <Container>
          <div className="TradeRadarAlgoFbHowItWork_grid">
            <Row>
              <Col lg={7} md={12}>
              
                <div className="TradeRadarAlgoFbHowItWork_videopanel">
                    <img src={TradeRadarAlgoFbHowItWork}></img>
                </div>
              </Col>
              <Col lg={5} md={12}>
              <div  className="TradeRadarAlgoFbHowItWork_grouppanel">
                {data2.map((value, index) => {
                  return (
                    <div Key={index} className="TradeRadarAlgoFbHowItWork_panel text-center">
                      <div className="TradeRadarAlgoFbHowItWork_img">
                        <img src={value.imgname} />
                      </div>
                        <h3>{value.title}</h3>
                      </div>
                    );
                    }
                    )
                    }
                </div>
                 <a className="knowmore-automatebaskt" href="#">Know More</a>
              </Col>
            </Row>
          </div>
        </Container>
        </div>
      </section>
    </>
  );
}
export default TradeRadarAlgoFbHowItWorks;
